import { type SelectOption } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'

import type { OperatorForm } from 'modules/reports/components/Editor/Field/Options/Types/Filtering/forms'
import type { FieldType } from 'modules/reports/components/Editor/Field/types'
import { operators, separatorAfterOperators } from 'modules/reports/lib/fieldHelper'
import { getOperatorLabel } from 'modules/reports/lib/operatorLabels'

interface Props {
  fieldType: FieldType
  form: OperatorForm
  onChange: () => void
}

const OperatorSelector = ({ fieldType, form, onChange }: Props) => {
  const { field } = fieldType

  if (!field) return null

  const optionsWithSeparators = (): SelectOption[] => {
    const separators = separatorAfterOperators(field)

    const options: SelectOption[] = operators(field).map((value) => ({
      value,
      label: getOperatorLabel(field.attributes.type, value),
    }))

    separators.forEach((separator) => {
      const index = options.findIndex((option) => option.value === separator) + 1
      options.splice(index, 0, {
        label: '-----',
        value: `key.${index}`,
        disabled: true,
      })
    })

    return options
  }

  return (
    <Select
      none={i18n.t('custom_reports.fields.filter_condition_none')}
      label={i18n.t('custom_reports.fields.filter_condition_label')}
      field={form.get('value')}
      options={optionsWithSeparators()}
      onChange={onChange}
    />
  )
}

export default observer(OperatorSelector)
